import { EntityValidityIcon as EntityValidityIconType } from '@/schemas/sceneDataSchema';
import { useEntityValidity } from '@/hooks/use-entity-validity';
import { IconColors, IconSizes } from '@/constants/iconTypes';
import { InertIcon } from './InertIcon';

export function EntityValidityIcon({ component }: { component: EntityValidityIconType }) {
  const isValid = useEntityValidity(component.scope, component.entity_index);

  return isValid ? (
    <InertIcon
      icon_name='check_circle'
      size={IconSizes.SMALL}
      color={IconColors.SUCCESS}
    />
  ) : (
    <InertIcon
      icon_name='warning'
      size={IconSizes.SMALL}
      color={IconColors.WARNING}
    />
  );
}
